var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M21.969 11.563V4.625a3.469 3.469 0 1 1 6.937 0v6.938a3.469 3.469 0 0 1-6.937 0ZM37 15.03a3.469 3.469 0 0 0 3.469-3.469V4.625a3.469 3.469 0 0 0-6.938 0v6.938A3.469 3.469 0 0 0 37 15.03Zm11.563 0a3.469 3.469 0 0 0 3.468-3.469V4.625a3.469 3.469 0 0 0-6.937 0v6.938a3.469 3.469 0 0 0 3.468 3.468Zm24.05 15.494-7.863 5.897v16.766a10.406 10.406 0 0 1-10.406 10.406H19.656A10.406 10.406 0 0 1 9.25 53.187V36.422l-7.862-5.897a3.469 3.469 0 1 1 4.162-5.55l3.7 2.775v-2.313a5.81 5.81 0 0 1 5.781-5.78H58.97a5.81 5.81 0 0 1 5.781 5.78v2.313l3.7-2.775a3.469 3.469 0 1 1 4.162 5.55Zm-14.8-3.931H16.187v26.593a3.469 3.469 0 0 0 3.47 3.47h34.687a3.469 3.469 0 0 0 3.468-3.47V26.595Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h74v74H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrep);
export default __webpack_public_path__ + "static/media/prep.bebbc2b330ac2617831bd7e4d02a2fe8.svg";
export { ForwardRef as ReactComponent };